/** The slice of `AnalyserNode` this adapter reads to derive a microphone input level. */
type CaptureAnalyser = {
	readonly fftSize: number;
	getByteTimeDomainData(buffer: Uint8Array): void;
};

/** What this adapter needs from an audio context: wiring a stream into an analyser, and disposal. */
type CaptureAudioContext = {
	connectStream(stream: MediaStream): CaptureAnalyser;
	close(): Promise<void>;
};

/**
 * Adapts a native `AudioPlayerContext` into the `CaptureAudioContext` shape: wires a given stream into a
 * freshly created analyser through a media stream source, and forwards disposal to `close()`.
 */
const wrapNativeAudioContext = (context: AudioContext): CaptureAudioContext => ({
	connectStream: (stream) => {
		const mediaStreamSource = context.createMediaStreamSource(stream);
		const analyser = context.createAnalyser();
		mediaStreamSource.connect(analyser);
		return analyser;
	},
	close: () => context.close(),
});

export default wrapNativeAudioContext;
export type { CaptureAudioContext, CaptureAnalyser };
